import { get } from 'svelte/store';
import { Configuration, DocumentsApi, DocumentsIndexTypeEnum } from '../api/rest/backoffice-data/generated';
import { Constants } from '../config/constants';
import { documentInnerNewsItems, keycloakError, newsPagination } from '../stores/stores';
import { recoverToken } from './AuthController';
import NewsApi from '../api/rest/directus-cms/news';
import { newsLabels } from '../stores/stores';
const platforms = process.env.PLATFORMS_NEWS
    ? process.env.PLATFORMS_NEWS.split(',')
    : undefined;
export const getNewsFromApi = async function getNews(lang, auth, limit, offset) {
    await recoverToken(auth);
    return new Promise((resolve, reject) => {
        if (auth.accessToken) {
            const config = new Configuration({
                basePath: process.env.BACKOFFICE_URL,
                accessToken: `${Constants.BEARER}${Constants.SPACE}${auth.accessToken}`
            });
            const documentApi = new DocumentsApi(config);
            documentApi
                .documentsIndex({
                locale: lang,
                type: DocumentsIndexTypeEnum.News,
                offset: offset,
                limit: limit,
                orderByField: 'publication_date',
                orderByType: 'DESC',
                platforms: platforms
            })
                .then(response => {
                keycloakError.set(false);
                filterNews(response, lang);
                resolve();
            })
                .catch(error => {
                keycloakError.set(true);
                console.error('Error:', error);
            });
        }
    });
};
export function filterNews(documentList, lang) {
    if (documentList.items) {
        const newList = [];
        documentList.items.map(element => {
            var _a;
            const a = Object.assign(Object.assign({}, element), { translations: (_a = element.translations) === null || _a === void 0 ? void 0 : _a.filter(translations => translations.languageCode === lang) });
            if (a) {
                newList.push(a);
            }
        });
        newsPagination.set(documentList.pagination);
        documentInnerNewsItems.set(newList);
    }
}
export async function fetchNewsLabels(lang) {
    await NewsApi.getInstance()
        .getNewsLabels(lang)
        .then(response => {
        newsLabels.set(response);
    })
        .catch(error => {
        console.log('Error fetching News Labels from CMS', error);
    });
}
